<template>
	<v-layout row wrap>
		<v-flex d-flex xs1>
			<v-card :color=firstCellColor>
				<v-card-text>
					<strong>
						{{firstCellLabel}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>

		<v-flex d-flex xs1 v-for="(value,index) in cellsValues" :key="index">
			<v-card :color=cellColor(index)>
				<v-card-text style="padding-left: 2px; padding-right: 2px">
					<strong>
						{{cellsFormatter(value)}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	import {FinalReportComparisonUtils} from "./Utils/FinalReportComparisonUtils";

	export default {
		name: 'FinalReportComparisonLargeRow',

		methods: {

			cellColor (index) {
				let status = FinalReportComparisonUtils.getComparisonStatusSingleProperty(
					this.cellsValues[index],
					this.cellsOtherValues[index],
					this.old,
					this.otherExists
				);
				return FinalReportComparisonUtils.comparisonColor(status, this.cellsColorIntensity);
			},

			parseColorValue (val) {
				if (val < 0) {
					return "grey darken-" + (-val);
				}
				return "grey lighten-" + val;
			}
		},

		props: {
			firstCellColor: {},
			firstCellLabel: {},
			cellsValues: {},
			cellsOtherValues: {},
			old: {},
			cellsFormatter: {},
			cellsColorIntensity: {},
			otherExists: {}
		}
	};
</script>
